import journalComponent from './journal.component';
import dischargeTableComponent from './discharge-table.component';
import dailyDataTableComponent from './daily-data-table.component';
import decadalDischargeTableComponent from './decadal-discharge-table.component';
import decadalMeteoTableComponent from './decadal-meteo-table.component';

export default angular.module('imomo.operational.journal', [])
    .component('imomoOperationalJournal', journalComponent)
    .component('imomoOperationalJournalDailyDataTable', dailyDataTableComponent)
    .component('imomoOperationalJournalDischargeTable', dischargeTableComponent)
    .component('imomoOperationalJournalDecadalDischargeTable', decadalDischargeTableComponent)
    .component('imomoOperationalJournalDecadalMeteoTable', decadalMeteoTableComponent)
    .name;



/** WEBPACK FOOTER **
 ** ./app/operational/journal/journal.module.ts
 **/